import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.cancelButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 15px;
    `,
};

changeCustomerSelectCustomerContainerStyles.container = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    min-height: 600px;
                `,
                css`
                    min-height: 600px;
                `,
                css``,
                null,
                null,
            ])}
    `,
};
